export interface WrappedValidate {
  validate: boolean;
}
